import Rx from "rxjs/Rx";

/*
    We assume that we have only 1 search panel.
 */

/*
    public API:
    - constructor
    - getCheckboxIndexes
    - events
    - initialized
 */
export default class RoomFilter {
    constructor() {
        this.initialized = false;
        this.checkboxes = null;
        this.selectionChangedSource = new Rx.Subject();
        this.events = {
            selectionChanged$: this.selectionChangedSource.asObservable(),
        };

        this.initialize();
    }

    initialize() {
        const searchPanels = document.getElementsByClassName("apartment-search-panel");

        if (!searchPanels.length) {
            this.initialized = false;
            return;
        }

        this.checkboxes = searchPanels[0].getElementsByClassName("room-filter")[0].getElementsByTagName("input");

        for (let i = 0; i < this.checkboxes.length; i++) {
            this.checkboxes[i].addEventListener("click", () => {
                this.selectionChangedSource.next();
                this.updateDataAttr();
            });
        }

        this.updateDataAttr();

        this.initialized = true;
    }

    updateDataAttr() {
        const node = document.getElementById("searchPanel");
        node.dataset.rooms = JSON.stringify(this.getCheckboxIndexes());
    }

    getCheckboxIndexes() {
        const result = [];

        for (let i = 0; i < this.checkboxes.length; i++) {
            if (this.checkboxes[i].checked) {
                result.push(i + 1);
            }
        }

        return result;
    }
}
